import { forwardRef } from 'react';

import { BadgePosition } from './AvatarWithBadge.types';

import { BadgeStyled } from './AvatarWithBadge.style';

export interface BadgeProps extends Omit<React.ComponentProps<'div'>, 'ref'> {
  /**
   * @default 'bottom-right'
   */
  position?: BadgePosition;
}

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(function Badge(
  { position = 'bottom-right', ...props }: BadgeProps,
  ref,
) {
  return <BadgeStyled ref={ref} $position={position} {...props} />;
});
